/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetFutureReservations200ResponseInnerStatus
 */
export interface GetFutureReservations200ResponseInnerStatus {
}

/**
 * Check if a given object implements the GetFutureReservations200ResponseInnerStatus interface.
 */
export function instanceOfGetFutureReservations200ResponseInnerStatus(value: object): value is GetFutureReservations200ResponseInnerStatus {
    return true;
}

export function GetFutureReservations200ResponseInnerStatusFromJSON(json: any): GetFutureReservations200ResponseInnerStatus {
    return GetFutureReservations200ResponseInnerStatusFromJSONTyped(json, false);
}

export function GetFutureReservations200ResponseInnerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFutureReservations200ResponseInnerStatus {
    return json;
}

export function GetFutureReservations200ResponseInnerStatusToJSON(json: any): GetFutureReservations200ResponseInnerStatus {
    return GetFutureReservations200ResponseInnerStatusToJSONTyped(json, false);
}

export function GetFutureReservations200ResponseInnerStatusToJSONTyped(value?: GetFutureReservations200ResponseInnerStatus | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

